import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-filter\"><path d=\"M1.854 2.854A.5.5 0 0 1 2.207 2h9.586a.5.5 0 0 1 .353.854l-3.5 3.5a.5.5 0 0 0-.146.353v2.879a1 1 0 0 1-.293.707l-1.853 1.853a.5.5 0 0 1-.854-.353V6.707a.5.5 0 0 0-.146-.353l-3.5-3.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol